import { render } from "./index.vue?vue&type=template&id=64454d7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=64454d7a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64454d7a"],['__file',"src/views/modelSetting/modelTask/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64454d7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64454d7a', __exports__)) {
    console.log('reload')
    api.reload('64454d7a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=64454d7a&scoped=true", () => {
    console.log('re-render')
    api.rerender('64454d7a', render)
  })

}


export default __exports__